import { createApi } from "@reduxjs/toolkit/query/react";
import { stringify } from "qs";

import { TEkoCropApiFilter } from "../../../modules/filter/shared/utils/eko-crop-filter-adapter";
import { verificationService } from "../../../modules/verification/shared/services/verification.service";
import { baseQuery } from "../../../shared/api/base-query";
import { IAssetUsageRecordDto } from "../shared/dtos/asset-usage-record.dto";
import { AssetUsageRecordListSchema } from "../shared/dtos/asset-usage-record.schema";
import { AssetUsageRecordStatus } from "../shared/enums/asset-usage-record-status";
import { TAssetUsageApiFilter } from "../shared/interfaces/asset-usage-api-filter";

type TAssetUsageApiFilterArg = TEkoCropApiFilter<TAssetUsageApiFilter>;

const verifyListResponse = verificationService.check({
  cacheId: "AssetUsageRecordListSchema",
  schema: AssetUsageRecordListSchema,
  message: "Невалидный ответ сервера (AssetUsageRecord)",
});

export interface IPrepareAssetsToSendResult {
  data: IAssetUsageRecordDto[];
  docsDownloadLink: string;
}

export const assetUsageRecordsApi = createApi({
  reducerPath: "assetUsageRecordsApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchAssetUsageRecords: builder.query<
      IAssetUsageRecordDto[],
      TAssetUsageApiFilterArg
    >({
      query: (filter) => ({
        url: buildAssetUsageRecordsUrl("AssetUsageRecords", filter),
      }),
      transformResponse: (data: IAssetUsageRecordDto[]) => verifyListResponse(data),
    }),

    fetchAssetUsageRecordsCount: builder.query<number, TAssetUsageApiFilterArg>({
      query: (filter) => ({
        url: buildAssetUsageRecordsUrl("AssetUsageRecords/count", filter),
      }),
    }),

    prepareAssetsToSend: builder.mutation<IPrepareAssetsToSendResult, string[]>({
      query: (ids) => ({
        url: "AssetUsageRecords",
        method: "PATCH",
        body: {
          data: ids.map((id) => ({ id, status: AssetUsageRecordStatus.PreparedToSend })),
        },
      }),
    }),
  }),
});

export function buildAssetUsageRecordsUrl(
  path: string,
  filter: TAssetUsageApiFilterArg
): string {
  const searchParams = stringify(filter, { arrayFormat: "repeat" });
  return searchParams ? `${path}?${searchParams}` : path;
}

export const {
  useFetchAssetUsageRecordsQuery,
  useFetchAssetUsageRecordsCountQuery,
  usePrepareAssetsToSendMutation,
} = assetUsageRecordsApi;
export const assetUsageRecordsApiReducer = assetUsageRecordsApi.reducer;
